import API from "../Axios";

class ContactUSApi {
  async postUserInfo(userInfo) {
    return await API.post("/guests/inbox", userInfo);
  }
}

export default new ContactUSApi();
